import React from 'react';

const Chat: React.FC = () => (
   <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M20.5 3.25V13.25C20.5 14.6307 19.3807 15.75 18 15.75H11.75L5.5 20.75V15.75H3C1.61929 15.75 0.5 14.6307 0.5 13.25V3.25C0.5 1.86929 1.61929 0.75 3 0.75H18C19.3807 0.75 20.5 1.86929 20.5 3.25ZM6.75 7H4.25V9.5H6.75V7ZM9.25 7H11.75V9.5H9.25V7ZM16.75 7H14.25V9.5H16.75V7Z" fill="#8787A1"/>
   </svg>
);

export default Chat;